import axios from 'axios';
import { buildQuery } from './helpers';

export const fetchCodes = (category, clientId, isSort) => {
    const query = {
        category,
        clientId,
        isSort
      };
    
      const queryParams = buildQuery(query);
           
      return axios.get('/api/shared/CodesTable?'+queryParams);
};
